exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-78040f49] {\n  fill: currentColor;\n  display: inline-block;\n  animation: spinIt-data-v-78040f49 1s infinite paused;\n}\n.icon.spin[data-v-78040f49] {\n  animation-play-state: running;\n}\n@keyframes spinIt-data-v-78040f49 {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
